<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>
          CANCELAMENTO DE FATURA ROYALTIES GRUPO
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="3">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                @click="search"
              >
                Executar Consulta
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="500">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left fs-12 text-no-wrap">
                                <v-checkbox
                                  v-model="checkall"
                                  hide-details
                                  :indeterminate="checkall === null"
                                  label=""
                                  class="mt-1"
                                  @click="handleClickCheckAll"
                                ></v-checkbox>
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Filial
                              </th>
                              <th class="text-left fs-12" width="250px">
                                Franqueado
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Documento
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Faturamento
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Vr. Documento
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Parcelas
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="royalty in royalties" :key="royalty.id">
                              <td>
                                <v-checkbox
                                  v-model="royalties_cancel"
                                  :value="royalty.id"
                                  hide-details
                                  label=""
                                  class="mt-1"
                                  @click="handleClickSelectRoyalty(royalty)"
                                ></v-checkbox>
                              </td>
                              <td>
                                {{ royalty.company.code }}
                              </td>
                              <td>
                                {{ royalty.company.name }}
                              </td>
                              <td>
                                {{ royalty.company.code }}-{{ royalty.code }}
                              </td>
                              <td>
                                {{ royalty.created_at | dateTimeToDateBr }}
                              </td>
                              <td class="text-right">
                                {{ royalty.value | currencyEuaToBr }}
                              </td>
                              <td class="text-right">
                                {{ royalty.installments.length }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn
                    dark
                    color="green darken-3"
                    class="float-right"
                    small
                    @click="handleConfirmCancel"
                  >
                    Confirmar Cancelamento
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog v-model="dialogCancel" max-width="400px">
      <v-card>
        <v-toolbar color="red lighten-1" dark class="text-h5"
          >Atenção</v-toolbar
        >
        <v-card-title class="text-h6">
          Tem certeza que deseja realmente <br />Cancelar essas Faturas de
          Royalties?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  :items="reasons"
                  item-text="description"
                  item-value="id"
                  v-model="reason"
                  :error="error_reason"
                  label="Motivo Para o Cancelamento"
                  required
                  :rules="[rules.required]"
                  @change="() => (error_reason = false)"
                  class="mt-5"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  outlined
                  no-resize
                  dense
                  name="input-7-4"
                  label="Observação"
                  class="text-field-uppercase"
                  :value="observation"
                  required
                  :rules="[rules.required]"
                  :error="error_observation"
                  @input="
                    (value) => {
                      observation = value;
                      error_observation = false;
                    }
                  "
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeCancel">Fechar</v-btn>
          <v-btn color="red darken-1" dark @click="cancelItemConfirm">
            <v-icon dark>mdi-delete</v-icon>
            Cancelar Fatura
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";

export default {
  components: { Alert },
  data: () => ({
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
    royalties: [],
    showAlert: false,
    typeAlert: "error",
    messageAlert: "",
    royalties_cancel: [],
    checkall: [],
    dialogCancel: false,
    error_reason: false,
    error_observation: false,
    reason: "",
    reasons: [],
    observation: "",
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    dateToBr: function (date) {
      if (date == undefined) return "";
      return date.split("-").reverse().join("/");
    },
    dateTimeToDateBr: function (datetime) {
      if (datetime == undefined) return "";
      let [date] = datetime.split(" ");
      return date.split("-").reverse().join("/");
    },
  },
  created() {
    let dateNow = new Date();
    this.month = dateNow.getMonth() + 1;
    this.year = dateNow.getFullYear();
    let yearNow = dateNow.getFullYear();

    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.getReasonsCancellation();
    },
    validate() {},
    handleClickSelectRoyalty() {
      if (this.royalties.length === this.royalties_cancel.length) {
        this.checkall = true;
      } else if (this.royalties_cancel.length === 0) {
        this.checkall = false;
      } else {
        this.checkall = null;
      }
    },
    handleClickCheckAll() {
      if (this.royalties.length === this.royalties_cancel.length) {
        this.checkall = false;
        this.royalties_cancel = [];
      } else {
        this.checkall = true;
        this.royalties_cancel = this.royalties.map((royalty) => royalty.id);
      }
    },
    async search() {
      this.checkall = false;
      this.showAlert = false;
      this.loading = true;
      this.royalties = [];
      this.royalties_cancel = [];

      let data = {};
      data.month = this.month;
      data.year = this.year;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let response = await fetch(`${URL}royalty/search`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        let res = await response.json();
        if (res.length > 0) {
          this.royalties = res.sort((a, b) => (a.code > b.code ? 1 : -1));
        } else {
          this.showAlert = true;
          this.typeAlert = "warning";
          this.messageAlert =
            "Nenhuma Fatura disponível para ser cancelada com os filtros selecionados";
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getTotalInvoices(royalty) {
      return royalty.invoices
        .map((item) => parseFloat(item.invoice.value))
        .reduce((prev, curr) => prev + curr, 0);
    },
    async getReasonsCancellation() {
      this.loading = true;
      try {
        let response = await fetch(`${URL}reason-cancellation-royalties`);
        let data = await response.json();
        this.reasons = data.sort((a, b) =>
          a.description > b.description ? 1 : -1
        );
      } catch (error) {
        this.reasons = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    handleConfirmCancel() {
      if (this.royalties_cancel.length > 0) {
        this.dialogCancel = true;
        this.reason = "";
        this.error_reason = false;
        this.error_observation = false;
        this.observation = "";
      } else {
        this.typeAlert = "error";
        this.messageAlert =
          "É preciso selecionar pelo menos uma fatura para cancelar";
        this.showAlert = true;
      }
    },
    closeCancel() {
      this.dialogCancel = false;
    },
    async cancelItemConfirm() {
      if (this.reason == "") {
        this.error_reason = true;
        return false;
      }
      if (this.observation == "") {
        this.error_observation = true;
        return false;
      }
      this.dialogCancel = false;
      this.loading = true;
      try {
        let data = {};
        data.royalties = this.royalties_cancel
          .map((item) => this.royalties.find((i) => i.id === item))
          .map((item) => ({
            company_id: item.company_id,
            id: item.id,
            code: item.code,
            reason_cancellation_royalty_id: this.reason,
            observation: this.observation.toUpperCase(),
            value: this.getTotalInvoices(item),
            royalties: item.value,
            date_billing: `${item.year_billing}-${item.month_billing}-01`,
            data_royalties: item,
          }));
        data.month = this.month;
        data.year = this.year;
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let response = await fetch(`${URL}royalty/group_cancel`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        let res = await response.json();
        console.log(res);
        this.checkall = false;
        this.reason = "";
        this.observation = "";
        this.error_observation = false;
        this.error_reason = false;
        this.showAlert = true;
        this.messageAlert = "Faturas Canceladas com Sucesso";
        this.typeAlert = "success";
        this.royalties_cancel = [];
        this.royalties = [];
      } catch (error) {
        console.log(error);
        this.showAlert = true;
        this.messageAlert = error.message;
        this.typeAlert = "error";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
</style>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
